import { render, staticRenderFns } from "./DropdownSelect.vue?vue&type=template&id=db08cbec&scoped=true"
import script from "./DropdownSelect.vue?vue&type=script&lang=js"
export * from "./DropdownSelect.vue?vue&type=script&lang=js"
import style0 from "./DropdownSelect.vue?vue&type=style&index=0&id=db08cbec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db08cbec",
  null
  
)

export default component.exports